import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

export function PlusButton({ onClick }) {
  return (
    <Button
      type="primary"
      onClick={onClick}
      icon={<PlusOutlined />}
      shape="circle"
      size="small"
    />
  );
}
